var chatRelativePath = '/chats';
var autoAssignRelativePath = '/auto-assign';
export var createChatApi = function (baseUrl, http) {
    var apiUrl = baseUrl + chatRelativePath;
    var autoAssignApiUrl = baseUrl + autoAssignRelativePath;
    return {
        startChat: function (startChatDto) {
            return http.post(apiUrl, startChatDto);
        },
        oldJoinChat: function (chatDto) {
            return http.post(apiUrl + "/" + chatDto.chatId + "/join", chatDto);
        },
        updateUser: function (updateChatUserDto) {
            return http.put(apiUrl + "/" + updateChatUserDto.chatId + "/user", updateChatUserDto);
        },
        getParticipants: function (chatDto) {
            return http.get(apiUrl + "/" + chatDto.chatId + "/participants");
        },
        oldLeaveChat: function (chatDto) {
            return http.post(apiUrl + "/" + chatDto.chatId + "/leave", chatDto);
        },
        oldEndChat: function (chatDto) {
            return http.post(apiUrl + "/" + chatDto.chatId + "/end", chatDto);
        },
        getStats: function (chatStatsDto) {
            return http.post(apiUrl + "/stats", chatStatsDto);
        },
        getStatsExtended: function (chatStatsDto) {
            return http.post(apiUrl + "/stats/extended", chatStatsDto);
        },
        getToken: function () {
            return http.get(apiUrl + "/token");
        },
        addAgentReply: function (addAgentReplyDto) {
            return http.post(apiUrl + "/new/" + addAgentReplyDto.ticketId + "/agentMessage", addAgentReplyDto);
        },
        joinChat: function (chatDto) {
            return http.post(apiUrl + "/new/" + chatDto.ticketId + "/join", chatDto);
        },
        leaveChat: function (chatDto) {
            return http.post(apiUrl + "/new/" + chatDto.ticketId + "/leave", chatDto);
        },
        endChat: function (chatDto) {
            return http.post(apiUrl + "/new/" + chatDto.ticketId + "/end", chatDto);
        },
        agentEndChat: function (chatDto) {
            return http.post(apiUrl + "/new/" + chatDto.ticketId + "/agents/end", chatDto);
        },
        getDashboardStats: function (chatStatsDto) {
            return http.post(apiUrl + "/stats/dashboard", chatStatsDto);
        },
        getActiveAgents: function (chatStatsDto) {
            return http.post(apiUrl + "/agents/active", chatStatsDto);
        },
        updateChatMessage: function (updateChatMsgDto) {
            return http.put(apiUrl + "/new/" + updateChatMsgDto.ticketId + "/messages/" + updateChatMsgDto.messageId, updateChatMsgDto);
        },
        deleteChatMessage: function (chatMsgDto) {
            return http.delete(apiUrl + "/new/" + chatMsgDto.ticketId + "/messages/" + chatMsgDto.messageId);
        },
        acceptChatJob: function (autoAssignJobDto) {
            return http.post(autoAssignApiUrl + "/accept/chat", autoAssignJobDto);
        },
        declineChatJob: function (autoAssignJobDto) {
            return http.post(autoAssignApiUrl + "/decline", autoAssignJobDto);
        },
        startOutboundChats: function (startOutboundChatsDto) {
            return http.post(apiUrl + "/outbound", startOutboundChatsDto);
        },
    };
};
//# sourceMappingURL=index.js.map